export const getSpaceValue = (value: number | [number, number], targetIdx?: 0 | 1) => {
  if (typeof value === 'number') return value;

  if (Array.isArray(value)) {
    if (targetIdx === undefined) return value[0];
    return value[targetIdx];
  }
};
